export default __webpack_public_path__ + "static/project-slide-2-992-765-380ea1495c746bfb157e774642ccce61.webp";